
const zonas = [
  // --- PLANTA BAJA: MESAS 1–26 ---
  { id: '31', label: 'mesa1', x: 145.44, y: 291.62, width: 38.44, height: 38.08 },
  { id: '42', label: 'mesa2', x: 226.69, y: 290.87, width: 38.24, height: 38.08 },
  { id: '50', label: 'mesa3', x: 145.44, y: 336.78, width: 38.44, height: 38.71 },
  { id: '51', label: 'mesa4', x: 226.63, y: 336.82, width: 38.37, height: 38.78 },
  { id: '52', label: 'mesa5', x: 145.56, y: 384.30, width: 38.21, height: 37.64 },
  { id: '53', label: 'mesa6', x: 226.60, y: 382.82, width: 38.44, height: 39.74 },
  { id: '54', label: 'mesa7', x: 146.00, y: 433.86, width: 39.07, height: 38.51 },
  { id: '55', label: 'mesa8', x: 225.87, y: 432.35, width: 38.84, height: 39.78 },
  { id: '56', label: 'mesa9', x: 145.98, y: 479.87, width: 37.37, height: 36.57 },
  { id: '32', label: 'mesa10', x: 226.06, y: 479.87, width: 37.37, height: 38.71 },
  { id: '33', label: 'mesa11', x: 146.07, y: 526.54, width: 37.17, height: 37.67 },
  { id: '34', label: 'mesa12', x: 226.60, y: 525.79, width: 38.44, height: 38.71 },
  { id: '35', label: 'mesa13', x: 146.51, y: 579.71, width: 38.44, height: 37.64 },
  { id: '36', label: 'mesa14', x: 226.67, y: 579.18, width: 38.44, height: 38.71 },
  { id: '37', label: 'mesa15', x: 145.44, y: 627.50, width: 38.44, height: 37.50 },
  { id: '38', label: 'mesa16', x: 226.72, y: 625.95, width: 37.81, height: 39.15 },
  { id: '39', label: 'mesa17', x: 145.44, y: 673.68, width: 38.44, height: 39.78 },
  { id: '40', label: 'mesa18', x: 226.60, y: 672.08, width: 38.44, height: 38.71 },
  { id: '41', label: 'mesa19', x: 145.98, y: 728.67, width: 37.37, height: 38.71 },
  { id: '43', label: 'mesa20', x: 225.50, y: 728.67, width: 39.48, height: 38.71 },
  { id: '44', label: 'mesa21', x: 145.44, y: 776.19, width: 38.44, height: 38.78 },
  { id: '45', label: 'mesa22', x: 226.60, y: 774.59, width: 38.44, height: 38.71 },
  { id: '46', label: 'mesa23', x: 145.88, y: 821.89, width: 39.31, height: 38.08 },
  { id: '47', label: 'mesa24', x: 225.60, y: 821.45, width: 39.31, height: 38.08 },
  { id: '48', label: 'mesa25', x: 144.98, y: 876.23, width: 39.31, height: 38.00 },
  { id: '49', label: 'mesa26', x: 226.60, y: 875.22, width: 38.44, height: 38.08 },

  // --- PLANTA BAJA: LOUNGES ---
  { id: 'LOUNGE1', label: 'LOUNGE1', x: 49, y: 326, width: 74.34, height: 80 },
  { id: 'LOUNGE2', label: 'LOUNGE2', x: 327.75, y: 347.17, width: 74.34, height: 80 },
  { id: 'LOUNGE3', label: 'LOUNGE3', x: 49, y: 413, width: 74.34, height: 80 },
  { id: 'LOUNGE4', label: 'LOUNGE4', x: 329.00, y: 493.99, width: 74.34, height: 80 },
  { id: 'LOUNGE5', label: 'LOUNGE5', x: 49, y: 525, width: 74.34, height: 80 },
  { id: 'LOUNGE6', label: 'LOUNGE6', x: 49, y: 612.95, width: 74.34, height: 80 },
  { id: 'LOUNGE7', label: 'LOUNGE7', x: 49, y: 720, width: 74.34, height: 80 },
  { id: 'LOUNGE8', label: 'LOUNGE8', x: 49, y: 808, width: 74.34, height: 80 },
  { id: 'LOUNGE9', label: 'LOUNGE9', x: 329.17, y: 775.99, width: 74.34, height: 80 },

  // --- 2DA PLANTA: LOUNGES VIP 1–11 (columna central) ---
  { id: '2P-LOUNGE1',  label: '2P-LOUNGE1',  x: 440, y: 300, width: 110, height: 40 },
  { id: '2P-LOUNGE2',  label: '2P-LOUNGE2',  x: 440, y: 350, width: 110, height: 40 },
  { id: '2P-LOUNGE3',  label: '2P-LOUNGE3',  x: 440, y: 400, width: 110, height: 40 },
  { id: '2P-LOUNGE4',  label: '2P-LOUNGE4',  x: 440, y: 450, width: 110, height: 40 },
  { id: '2P-LOUNGE5',  label: '2P-LOUNGE5',  x: 440, y: 500, width: 110, height: 40 },
  { id: '2P-LOUNGE6',  label: '2P-LOUNGE6',  x: 440, y: 550, width: 110, height: 40 },
  { id: '2P-LOUNGE7',  label: '2P-LOUNGE7',  x: 440, y: 600, width: 110, height: 40 },
  { id: '2P-LOUNGE8',  label: '2P-LOUNGE8',  x: 440, y: 650, width: 110, height: 40 },
  { id: '2P-LOUNGE9',  label: '2P-LOUNGE9',  x: 440, y: 700, width: 110, height: 40 },
  { id: '2P-LOUNGE10', label: '2P-LOUNGE10', x: 440, y: 750, width: 110, height: 40 },
  { id: '2P-LOUNGE11', label: '2P-LOUNGE11', x: 440, y: 800, width: 110, height: 40 },

  // --- 2DA PLANTA: PALCO SUPER VIP (columna derecha punteada: 10–7 / 6–4) ---
  // Bloque superior: 10, 9, 8, 7
  { id: '2P-PALCO10', label: '2P-PALCO10', x: 620, y: 300, width: 70, height: 60 },
  { id: '2P-PALCO9',  label: '2P-PALCO9',  x: 620, y: 365, width: 70, height: 60 },
  { id: '2P-PALCO8',  label: '2P-PALCO8',  x: 620, y: 430, width: 70, height: 60 },
  { id: '2P-PALCO7',  label: '2P-PALCO7',  x: 620, y: 495, width: 70, height: 60 },

  // Bloque inferior: 6, 5, 4 (debajo del texto "BARRA PLANTA ALTA")
  { id: '2P-PALCO6',  label: '2P-PALCO6',  x: 620, y: 670, width: 70, height: 60 },
  { id: '2P-PALCO5',  label: '2P-PALCO5',  x: 620, y: 735, width: 70, height: 60 },
  { id: '2P-PALCO4',  label: '2P-PALCO4',  x: 620, y: 800, width: 70, height: 60 },

  // --- 2DA PLANTA: LOUNGES VIP frontal (12,13,14,15 arriba / 1,2,3 abajo) ---
  // Fila superior: 12, 13
  { id: '2P-PALCO12', label: '2P-PALCO12', x: 50, y: 930, width: 40, height: 110 },
  { id: '2P-PALCO13', label: '2P-PALCO13', x: 330, y: 930, width: 40, height: 110 },

  // Fila inferior: 1, 2, 3
  { id: '2P-PALCO1', label: '2P-PALCO1', x: 90, y: 1050, width: 70, height: 60 },
  { id: '2P-PALCO2', label: '2P-PALCO2', x: 170, y: 1050, width: 70, height: 60 },
  { id: '2P-PALCO3', label: '2P-PALCO3', x: 250, y: 1050, width: 70, height: 60 }
];

export default zonas;
